export class StatusEnum {
    static DRAFT = "draft";

    static PUBLISHED = "published";
}

export default StatusEnum;
